export default (theme) => ({
  waitingCallSettingsForm: {
    width: '100%',
    height: 'calc(100% - 50px)',
  },
  videoCallSettingsForm: {
    height: 'auto',
  },
  scroll: {
    width: '70%',
    height: '100%',
    overflowY: 'auto',
    margin: 'auto',
    [theme.breakpoints.down('xl')]: {
      width: '100%',
    },
    [theme.breakpoints.down('md')]: {
      padding: '0 30px',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '0 16px',
    },
  },
  cameraTest: {
    width: '100%',
    minHeight: 200,
    height: 'calc(50% - 20px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 40,
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column-reverse',
      marginTop: 0,
      height: 'auto',
      minHeight: 'initial',
    },
  },
  testingSettings: {
    width: '100%',
    height: 'auto',
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 20,
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      marginTop: 0,
      height: 'auto',
    },
  },
  centeredTestingSettings: {
    justifyContent: 'center',
    height: '100%',
    marginTop: 0,
  },
  item: {
    width: 'calc(50% - 10px)',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('md')]: {
      marginTop: 20,
      width: '100%',
      minHeight: 300,
      height: 'auto',
    },
    [theme.breakpoints.down('sm')]: {
      minHeight: 200,
    },
  },
  centeredItem: {
    height: 'initial',
    paddingTop: 5,
    maxWidth: '90%',
    minWidth: 390,
    [theme.breakpoints.down('sm')]: {
      minWidth: 'initial',
      maxWidth: '100%',
    },
  },
  videoPreviewItem: {
    width: 'calc(50% - 10px)',
    height: '100%',
    [theme.breakpoints.down('md')]: {
      minHeight: 500,
      height: 500,
      marginTop: 20,
      width: '100%',
    },
    [theme.breakpoints.down('sm')]: {
      minHeight: 350,
      height: 350,
    },
  },
  label: {
    margin: '0 25px 0 0',
    [theme.breakpoints.down('sm')]: {
      margin: '0 10px 0 0',
    },
  },
  labelIcon: {
    height: '100%',
    width: 25,
    fill: theme.palette.disabled.main,
    verticalAlign: 'middle',
  },
  select: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 20,
    '&:first-of-type': {
      marginTop: 0,
    },
  },
  micTest: {
    margin: '20px 0 10px 0',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  joinButton: {
    height: 70,
    width: '75%',
    marginBottom: 20,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  joinButtonIcon: {
    minWidth: 23,
    minHeight: 23,
    width: 23,
    height: 23,
    fill: theme.palette.background.white,
  },
  controlButtonText: {
    marginLeft: 10,
    fontSize: 19,
    [theme.breakpoints.down('xl')]: {
      fontSize: 14,
    },
  },
  joinSession: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    textAlign: 'center',
    marginTop: 23,
    [theme.breakpoints.down('md')]: {
      justifyContent: 'flex-start',
    },
    [theme.breakpoints.down('sm')]: {
      paddingBottom: 100,
    },
  },
  webcamVideo: {
    height: '100%',
    width: '100%',
    objectFit: 'contain',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%) scaleX(-1)',
  },
  updateNameButton: {
    height: 45,
    paddingLeft: 20,
    paddingRight: 20,
    marginLeft: 20,
  },
});
